<template>
  <v-dialog v-model="isDialogOpenCreate" max-width="720" persistent>
    <v-card rounded="xl" elevation="8">
      <!-- HEADER -->
      <v-card-title class="d-flex align-center justify-space-between px-6 py-4">
        <div>
          <div class="text-h6 font-weight-bold">Tambah Data COA</div>

          <div class="text-caption text-medium-emphasis">
            Lengkapi informasi akun dengan benar
          </div>
        </div>

        <v-btn
          icon
          variant="text"
          size="small"
          @click="isDialogOpenCreate = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider />

      <!-- BODY -->
      <v-card-text class="pa-6">
        <v-form ref="formCreate" v-model="isFormValidCreate">
          <v-row>
            <v-col cols="12" sm="6">
              <v-select
                v-model="level_acc_1"
                :items="listLevelAcc1"
                label="Level Acc 1"
                placeholder="Pilih Level Acc 1"
                outlined
                dense
                prepend-inner-icon="mdi-shape-outline"
                :rules="[(v) => !!v || 'Level Acc 1 wajib diisi']"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="level_acc_2"
                label="Level Acc 2"
                placeholder="Masukkan Level Acc 2"
                variant="outlined"
                density="comfortable"
                prepend-inner-icon="mdi-code-tags"
                :rules="rules.required"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="level_acc_3"
                label="Level Acc 3"
                placeholder="Masukkan Level Acc 3"
                variant="outlined"
                density="comfortable"
                prepend-inner-icon="mdi-code-tags"
                :rules="rules.required"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="level_acc_4"
                label="Level Acc 4"
                placeholder="Masukkan Level Acc 4"
                variant="outlined"
                density="comfortable"
                prepend-inner-icon="mdi-code-tags"
                :rules="rules.required"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="level_acc_5"
                label="Level Acc 5"
                placeholder="Masukkan Level Acc 5"
                variant="outlined"
                density="comfortable"
                prepend-inner-icon="mdi-code-tags"
                :rules="rules.required"
              />
            </v-col>

            <!-- Account -->
            <v-col cols="12" md="6">
              <v-text-field
                v-model="account"
                label="Account"
                placeholder="Masukkan Account"
                variant="outlined"
                density="comfortable"
                prepend-inner-icon="mdi-code-tags"
                :rules="rules.required"
              />
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <v-select
                v-model="corporate_id"
                :items="listCorporate"
                label="Perusahaan"
                placeholder="Pilih perusahaan"
                outlined
                dense
                prepend-inner-icon="mdi-office-building-outline"
                item-text="mst_corporate_name"
                item-value="mst_corporate_id"
                clearable
                :rules="[(v) => !!v || 'Perusahaan wajib dipilih']"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="account_combination"
                label="Account Combination"
                placeholder="42.07.B100.000.11101001.0000"
                outlined
                dense
                prepend-inner-icon="mdi-database-outline"
                maxlength="28"
                persistent-hint
                hint="Format: 42.07.B100.000.11101001.0000"
                :rules="[
                  (v) => !!v || 'Account Combination wajib diisi',
                  (v) =>
                    /^\d{2}\.\d{2}\.[A-Z0-9]{4}\.\d{3}\.\d{8}\.\d{4}$/.test(
                      v,
                    ) || 'Format Account Combination tidak valid',
                ]"
                @input="formatCoaOracle"
              />
            </v-col>

            <!-- DESCRIPTION -->
            <v-col cols="12">
              <v-textarea
                v-model="description"
                label="Deskripsi"
                placeholder="Masukkan deskripsi akun"
                variant="outlined"
                density="comfortable"
                prepend-inner-icon="mdi-text-box-outline"
                auto-grow
                rows="3"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider />

      <!-- FOOTER -->
      <v-card-actions class="px-6 py-4">
        <v-spacer />

        <v-btn
          variant="outlined"
          color="secondary"
          @click="isDialogOpenCreate = false"
        >
          Cancel
        </v-btn>

        <v-btn
          color="primary"
          variant="flat"
          :disabled="!isFormValidCreate"
          @click="submitCreate"
        >
          <v-icon start> mdi-content-save </v-icon>

          Simpan
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "@/utils/api";
import store from "@/store";

export default {
  name: "DialogCoa",

  data() {
    return {
      listCorporate: [],
      // MASTER

      listLevelAcc1: [
        "ASET",
        "LIABILITAS",
        "EKUITAS",
        "PENDAPATAN",
        "BEBAN LANGSUNG",
        "BEBAN USAHA",
        "PENDAPATAN/BEBAN LAIN-LAIN",
        "LAIN-LAIN",
      ],

      // FORM
      id: null,
      level_acc_1: null,
      level_acc_2: null,
      level_acc_3: null,
      level_acc_4: null,
      level_acc_5: null,
      account: null,
      account_combination: null,
      description: null,
      corporate_id: null,

      // UI
      isDialogOpenCreate: false,
      isFormValidCreate: false,
      isLoadingSubmit: false,

      // VALIDATION
      rules: {
        required: [(v) => !!v || "Field wajib diisi"],

        requiredNumber: [
          (v) =>
            v !== null && v !== "" && v !== undefined
              ? true
              : "Field wajib diisi",
        ],
      },
    };
  },

  methods: {
    async fetchCorporate() {
      try {
        const { data } = await api.get("/corporates", {
          params: {
            category: "GROUP",
          },
        });

        this.listCorporate = (data?.data?.data || []).filter((e) =>
          e.mst_corporate_name?.toLowerCase().includes("fastana"),
        );
      } catch (error) {
        store.dispatch("triggerSnackbar", {
          message: error?.response?.data?.message || "Failed fetch corporate",
          isSuccess: false,
        });
      } finally {
        store.dispatch("hideLoading");
      }
    },
    formatCoaOracle(value) {
      // Hapus semua titik dulu
      let raw = value.replace(/\./g, "");

      let result = "";

      const segments = [2, 2, 4, 3, 8, 4];
      let index = 0;

      for (let i = 0; i < segments.length; i++) {
        const seg = raw.slice(index, index + segments[i]);
        if (!seg) break;
        result += (i > 0 ? "." : "") + seg;
        index += segments[i];
      }

      this.account_combination = result;
    },
    // =========================
    // OPEN DIALOG
    // =========================
    openDialogCreate(payload = {}) {
      this.resetForm();
      this.id = payload.id || null;
      this.account_combination = payload.searchCoa || null;
      this.isDialogOpenCreate = true;
    },

    // =========================
    // RESET FORM
    // =========================
    resetForm() {
      this.id = null;
      this.level_acc_1 = null;
      this.level_acc_2 = null;
      this.level_acc_3 = null;
      this.level_acc_4 = null;
      this.level_acc_5 = null;
      this.account = null;
      this.account_combination = null;
      this.corporate_id = null;
      this.description = null;

      this.isFormValidCreate = false;

      this.$nextTick(() => {
        if (this.$refs.formCreate) {
          this.$refs.formCreate.resetValidation();
        }
      });
    },

    // =========================
    // SUBMIT CREATE
    // =========================
    async submitCreate() {
      const isValid = this.$refs.formCreate.validate();

      if (!isValid) return;

      this.isLoadingSubmit = true;

      store.dispatch("showLoading");

      try {
        const payload = {
          level_acc_1: this.level_acc_1,
          level_acc_2: this.level_acc_2,
          level_acc_3: this.level_acc_3,
          level_acc_4: this.level_acc_4,
          level_acc_5: this.level_acc_5,
          account: this.account,
          account_combination: this.account_combination,
          corporate_id: this.corporate_id,
          description: this.description,
        };

        const response = await api.post("/coa", payload);

        const message = response.data.message || "Berhasil menambahkan data";

        // emit ke parent
        this.$emit("success", response.data);

        // close dialog
        this.isDialogOpenCreate = false;

        // reset form
        this.resetForm();

        // snackbar
        store.dispatch("triggerSnackbar", {
          message,
          isSuccess: true,
        });
      } catch (error) {
        let message = "Gagal menambahkan data!";

        if (error.response) {
          message = error.response.data.message || message;
        } else {
          message = error.message || message;
        }

        store.dispatch("triggerSnackbar", {
          message,
          isSuccess: false,
        });
      } finally {
        this.isLoadingSubmit = false;

        store.dispatch("hideLoading");
      }
    },
  },
  mounted() {
    this.fetchCorporate();
  },
};
</script>
